export enum WidgetTestVariant {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
}
